import { render, staticRenderFns } from "./livemeetingManagement.vue?vue&type=template&id=671561de&scoped=true"
import script from "./livemeetingManagement.vue?vue&type=script&lang=js"
export * from "./livemeetingManagement.vue?vue&type=script&lang=js"
import style0 from "./livemeetingManagement.vue?vue&type=style&index=0&id=671561de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671561de",
  null
  
)

export default component.exports